import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({selector: '[queryOperator]'})
export class QueryOperatorDirective {
  constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/plugins/queryBuilder/components/query-builder/query-operator.directive.ts